type PhotoCategory = "before" | "during" | "after";

export function createInterventionPhotoTokenRegistry(
  randomUUID: () => string = () => crypto.randomUUID(),
) {
  const photoIds = new Map<string, string>();

  return {
    get(category: PhotoCategory, file: File) {
      const fingerprint = [
        category,
        file.name,
        file.type,
        file.size,
        file.lastModified,
      ].join(":");
      const photoId = photoIds.get(fingerprint) ?? randomUUID();
      photoIds.set(fingerprint, photoId);
      return { fingerprint, photoId };
    },
    complete(fingerprint: string) {
      photoIds.delete(fingerprint);
    },
  };
}

export function interventionPhotoUploadUrl(
  interventionId: string,
  category: PhotoCategory,
  photoId: string,
) {
  return `/api/uploads/interventions/${encodeURIComponent(interventionId)}?category=${category}&photoId=${encodeURIComponent(photoId)}`;
}
